import React, { useState } from "react";
import { Container, FormGroup, Label, Input, Row, Col } from "reactstrap";
import { Eye, EyeOff } from "assets";
import { Bell } from "assets";
import { FiArrowLeft } from "react-icons/fi";
import { FormCreatableSelects, FormInputs } from "components/FormInputSelect";
import CustomButton from "components/CustomButton";
import CustomInput from "pages/auth/CustomInput";
import { API_POST_MAMBOO, API_PUT_MAMBOO } from "services";
import { Alert } from "components/Alert";

const AddAdmin = ({ handleBack, access, role, setRole, dataDetail, page }) => {
  const [addAnggotaForm, setAddAnggotaForm] = useState({
    password: "",
    repeatPassword: "",
    nama_lengkap: dataDetail?.name || "",
    email: dataDetail?.email || "",
    registrasi_sebagai: dataDetail?.admin_role[0] || ""
  });



  const [isPasswordShow, setIsPasswordShow] = useState({
    password: false,
    repeatPassword: false,
  });

  const [inputError, setInputError] = useState({
    password: [],
    repeatPassword: [],
  });

  const [newRole, setNewRole] = useState([])

  const [selectedAccess, setSelectedAccess] = useState(page ?
    dataDetail.access.map((val) => val)
    : access.map((val) => {
      return {
        access_code: val.access_code,
        is_checked: false,
        is_read_only: false
      }
    }))

  const [isDisabled, setIsDisabled] = useState(true);
  const [isError, setError] = useState('')

  const errorMessage = {
    password: ["Kata sandi terlalu pendek, minimal 8 karakter", "Harus berisi setidaknya satu huruf kapital", "Harus berisi setidaknya satu angka", "Setidaknya harus mengandung karakter khusus"],
    repeatPassword: ["Kata sandi tidak sama"],
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "5px",
    }),

    // valueContainer: (provided, state) => ({
    //     ...provided,
    //     height: '20px',
    //     padding: '0 6px'
    // }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      padding: "16px",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      margin: "0px",
      padding: "16px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
  };
  const customStylesNama = {
    control: (provided, state) => ({
      ...provided,
      border: "1px solid var(--border)",
      borderRadius: "8px",
      outline: 'none'
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: '0 8px',
      fontSize: '14px'
    }),
    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      padding: "16px",
      width: "176px",
      border: "none",
      outline: "none"
    }),
    placeholder: (provided, state) => ({
      ...provided,
      margin: "0px",
      paddingLeft: "8px",
      color: 'var(--text-placeholder)'
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
  };

  const passwordIconAction = (name) => {
    setIsPasswordShow({ ...isPasswordShow, [name]: !isPasswordShow[name] });
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    let re;
    let isValid;
    switch (name) {
      case "password":
        const regPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
        isValid = regPassword.test(value)
        break;
      case "repeatPassword":
        isValid = addAnggotaForm.password === value || value === "";
        break;
      default:
        break;
    }
    if (re) isValid = re.exec(value) ? false : true;

    setAddAnggotaForm({ ...addAnggotaForm, [name]: value });
    if (!isValid)
      return setInputError({ ...inputError, [name]: errorMessage[name] });
    if (isValid) return setInputError({ ...inputError, [name]: "" });
  };


  const registerAdmin = async (data) => {
    await API_POST_MAMBOO.actions.saveAdmin(data)
      .then((response) => {
          handleBack();
      })
      .catch((err) => {
        // setError(err.response.data.data)
        throw new Error(err.response.data.data)
      })
  }

  const createRoleAdmin = async (data) => {
    await API_POST_MAMBOO.actions.saveRoleAdmin(data)
      .then((response) => {
        // console.log(response)
      }).catch((err) => {

      })
  }

  const updateDataAdmin = async (data) => {
    await API_PUT_MAMBOO.update.updateAdmin(data)
    .then((response) => {
      console.log(response)
    })
    .catch((err) => {
      throw new Error(err.response.data.data)
    })
  }

  const handleClickSimpan = async () => {
    const dataToSave = {
      profile: {
        name: addAnggotaForm.nama_lengkap,
        role_code: 2,
        admin_role: [addAnggotaForm.registrasi_sebagai]
      },
      access: selectedAccess
    }

    // console.log(dataToSave)
    // console.log({ role, newRole })
    const payload = new URLSearchParams()
    payload.append('payload', JSON.stringify(dataToSave))
    payload.append('email', addAnggotaForm.email)
    payload.append('password', addAnggotaForm.password)

    if(page) {
      payload.append('admin_id', dataDetail.user_id)
    }

    Alert({
      icon: 'warning',
      title: `${page ? 'Edit' : 'Tambah'} Admin`,
      text: `Pastikan data yang terisi sudah benar`,
      showCancelButton: true,
      showConfirmButton: true,
      showLoaderOnConfirm: true,
      confirmButtonText: 'Ya',
      cancelButtonText: 'Batal',
      confirmButtonColor: 'var(--danger)',
      successText: `Admin '${addAnggotaForm.nama_lengkap}' berhasil di${page ? 'edit' : 'tambahkan'}`,
      cancelText: `Admin '${addAnggotaForm.nama_lengkap}' batal di${page ? 'edit' : 'tambahkan'}`,
      confirmed: () => page === "edit" ? updateDataAdmin(payload) : registerAdmin(payload)
    })

    // await registerAdmin(payload)
    await createRoleAdmin(newRole)
  }

  const onCreateOption = async (newOption) => {
    await setNewRole((prev) => [...prev, newOption])
    await setRole((prev) => ([...prev, { label: newOption, value: newOption }]))
    onChangeSelect({ label: newOption }, 'test')
  }

  const onChangeSelect = (val, po) => {
    if (val) {
      setAddAnggotaForm((prev) => ({ ...prev, registrasi_sebagai: val.label }))
    } else {
      setAddAnggotaForm((prev) => ({ ...prev, registrasi_sebagai: "" }))
    }
  }

  const superAdminIndex = access.findIndex((a) => a.access_name === 'Super Admin')
  const isSuperAdminChecked = superAdminIndex !== -1 && selectedAccess[superAdminIndex]?.is_checked

  const onCheckChange = (e, index, accessName) => {
    const { checked, name } = e.target
    const currentData = [...selectedAccess]

    if (accessName === 'Super Admin' && !name) {
      setSelectedAccess(currentData.map((item) => ({
        ...item,
        is_checked: checked,
        is_read_only: false
      })))
      return
    }

    if (name) {
      currentData[index].is_read_only = checked
    } else {
      currentData[index].is_checked = checked
      if (!checked) currentData[index].is_read_only = false
    }
    setSelectedAccess(currentData)
  }

  return (
    <>
      <Container fluid className="content-pencipta">
        <div className="header-content">
          <div className="pencipta-header">
            <h1>{page ? 'Edit Data' : 'Register'} Admin</h1>
          </div>
          <div className="icon-wrapper">
            <Bell />
          </div>
        </div>
        <div className="tabs-filters">
          <div className="frame-filters">
            <CustomButton
              label="Kembali"
              size="md"
              iconPosition="left"
              LabelIcon={FiArrowLeft}
              className="button-kembali"
              onClick={handleBack}
            />
          </div>
        </div>
        <div className="scope-container">
          <div className="frame-lainnya-password">
            <div className="informasi-lainnya">
              <div className="text-lainnya">Informasi Umum</div>
              <div className="frame-lainnya">
                <div className="text-telepon">Nama Lengkap</div>
                <FormInputs
                  placeholder="Admin Publishing 2"
                  className="frame-inputs"
                  name="nama_lengkap"
                  value={addAnggotaForm.nama_lengkap}
                  onChange={onChange}
                />
              </div>
              <div className="frame-lainnya">
                <div className="text-telepon">Email</div>
                <FormInputs
                  placeholder="Email@email.com"
                  className="frame-inputs"
                  value={addAnggotaForm.email}
                  isDisabled={page === 'edit'}
                  name="email"
                  onChange={onChange}
                />
              </div>
              <div className="frame-lainnya">
                <div className="text-telepon">Registrasi Sebagai</div>
                {/* <FormInputs
                  placeholder="Admin Publishing 2"
                  className="frame-inputs"
                /> */}
                <FormCreatableSelects
                  placeholder='Masukan Nama'
                  formatCreateLabel={(string) => `Buat Role '${string}'`}
                  onCreateOption={(string) => onCreateOption(string)}
                  options={role}
                  backspaceRemovesValue={true}
                  isClearable={true}
                  required={true}
                  value={addAnggotaForm.registrasi_sebagai}
                  onChange={(val) => onChangeSelect(val)}
                  styles={customStylesNama}
                />
              </div>
              <FormGroup className="custom-form-group">
                <CustomInput
                  label="Password"
                  name="password"
                  placeholder="Password"
                  required={true}
                  onChange={onChange}
                  value={addAnggotaForm.password}
                  type={`${isPasswordShow.password ? "text" : "password"}`}
                  Icon={isPasswordShow.password ? Eye : EyeOff}
                  iconPosition="right"
                  iconAction={() => passwordIconAction("password")}
                  errorArr={inputError.password}
                />
              </FormGroup>
              <FormGroup className="custom-form-group">
                <CustomInput
                  label="Ulangi Password"
                  required={true}
                  name="repeatPassword"
                  placeholder="Password"
                  onChange={onChange}
                  value={addAnggotaForm.repeatPassword}
                  type={`${isPasswordShow.repeatPassword ? "text" : "password"
                    }`}
                  Icon={isPasswordShow.repeatPassword ? Eye : EyeOff}
                  iconPosition="right"
                  iconAction={() => passwordIconAction("repeatPassword")}
                  errorArr={inputError.repeatPassword}
                />
              </FormGroup>
            </div>
          </div>

          <div className="frame-bank-verified">
            <div className="data-bank" style={{ height: 'calc(100%)' }}>
              <div className="text-data-bank">Akses Admin</div>
              <Row className="frame-checkbox">
                {access.map((val, index) => {
                  const isSuperAdminItem = val.access_name === 'Super Admin'
                  const isDisabledBySuper = isSuperAdminChecked && !isSuperAdminItem
                  return (
                    <>
                      <Col sm={6} style={{ marginBottom: '7px' }}>
                        <Label check style={{ color: isDisabledBySuper ? 'var(--text-muted)' : undefined }}>
                          <Input
                            type="checkbox"
                            checked={selectedAccess[index].is_checked}
                            disabled={isDisabledBySuper}
                            onChange={(e) => onCheckChange(e, index, val.access_name)}
                          /> {val.access_name}
                        </Label>
                      </Col>
                      <Col sm={6} style={{ marginBottom: '7px' }}>
                        {!isSuperAdminItem && (
                          <Label check style={{ color: (!selectedAccess[index].is_checked || isDisabledBySuper) ? 'var(--text-muted)' : undefined }}>
                            <Input
                              type="checkbox"
                              checked={selectedAccess[index].is_read_only}
                              disabled={!selectedAccess[index].is_checked || isDisabledBySuper}
                              name="readOnly"
                              onChange={(e) => onCheckChange(e, index, val.access_name)}
                            /> View Only
                          </Label>
                        )}
                      </Col>
                    </>
                  )
                })}
              </Row>
            </div>
          </div>
        </div>
        <div className='frame-button-simpan'>
          <CustomButton
            label={page ? 'Simpan Perubahan' : 'Registrasi Anggota'}
            color={false ? "secondary-btn" : "primary-btn"}
            className="btn-simpan"
            onClick={handleClickSimpan}
            disabled={isDisabled ? false : false}
          />
        </div>
      </Container>
    </>
  );
};

export default AddAdmin;
